import { render, staticRenderFns } from "./Pruksa.vue?vue&type=template&id=06d36430&scoped=true"
import script from "./Pruksa.vue?vue&type=script&lang=js"
export * from "./Pruksa.vue?vue&type=script&lang=js"
import style0 from "./Pruksa.vue?vue&type=style&index=0&id=06d36430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d36430",
  null
  
)

export default component.exports